/**
 * @fileoverview GET handler for the "/app_settings/objects_using_custom_attributes" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsObjectsUsingCustomAttributes } from "./constants";
import type { AppSettingsObjectsUsingCustomAttributesResult } from "./types";

export const getAppSettingsObjectsUsingCustomAttributes = reactQueryFetcherAdapter(
  appSettingsObjectsUsingCustomAttributes,
  (signal: AbortSignal, itemNames: string[]): Promise<AppSettingsObjectsUsingCustomAttributesResult> => {
    return fetch("/app_settings/objects_using_custom_attributes", "GET", { item_names: itemNames }, { signal });
  }
);
